/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsUserImage,
    SharedserviceMelcoModelsUserImageFromJSON,
    SharedserviceMelcoModelsUserImageFromJSONTyped,
    SharedserviceMelcoModelsUserImageToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoFusionModelsCreateBlank
 */
export interface SharedserviceMelcoFusionModelsCreateBlank {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoFusionModelsCreateBlank
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoFusionModelsCreateBlank
     */
    canvas_width?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoFusionModelsCreateBlank
     */
    canvas_height?: number;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsUserImage>}
     * @memberof SharedserviceMelcoFusionModelsCreateBlank
     */
    images?: Array<SharedserviceMelcoModelsUserImage> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SharedserviceMelcoFusionModelsCreateBlank
     */
    colors?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SharedserviceMelcoFusionModelsCreateBlank
     */
    views?: Array<string> | null;
}

export function SharedserviceMelcoFusionModelsCreateBlankFromJSON(json: any): SharedserviceMelcoFusionModelsCreateBlank {
    return SharedserviceMelcoFusionModelsCreateBlankFromJSONTyped(json, false);
}

export function SharedserviceMelcoFusionModelsCreateBlankFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoFusionModelsCreateBlank {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'canvas_width': !exists(json, 'canvas_width') ? undefined : json['canvas_width'],
        'canvas_height': !exists(json, 'canvas_height') ? undefined : json['canvas_height'],
        'images': !exists(json, 'images') ? undefined : (json['images'] === null ? null : (json['images'] as Array<any>).map(SharedserviceMelcoModelsUserImageFromJSON)),
        'colors': !exists(json, 'colors') ? undefined : json['colors'],
        'views': !exists(json, 'views') ? undefined : json['views'],
    };
}

export function SharedserviceMelcoFusionModelsCreateBlankToJSON(value?: SharedserviceMelcoFusionModelsCreateBlank | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'canvas_width': value.canvas_width,
        'canvas_height': value.canvas_height,
        'images': value.images === undefined ? undefined : (value.images === null ? null : (value.images as Array<any>).map(SharedserviceMelcoModelsUserImageToJSON)),
        'colors': value.colors,
        'views': value.views,
    };
}


